<template>
  <div class="container">
    <div class="exam">
      <div class="exam-head">
        <div class="exam-head-title">
          <p>答题进度：<span class="exam-progress">{{ examProgress }} / {{ examTotal }}</span></p>
          <p>用时：<span class="exam-time">{{ examTime }}</span></p>
        </div>
        <nut-progress :percentage="currentPercent" stroke-color="#fff" :show-text="false" size="small" stroke-width="9">
        </nut-progress>
      </div>
      <div class="exam-body">
        <template v-for="(item, index) in data">
          <Subject :key="`${index}`" v-if="index === examProgress - 1" :data="item" @change="change"></Subject>
        </template>
      </div>
      <div class="exam-foot" v-if="showNext">
        <div class="exam-foot-btn">
          <nut-button type="primary" @click="next" style="background: linear-gradient(270deg, #FFAC49 0%, #F87200 100%);
    box-shadow: 0px 2px 13px 0px rgba(0,0,0,0.5);
    width: 100%;
    border-radius: 45px;
    height: 45px;">{{ examProgress === examTotal ? '提交答题结果' : '下一题' }}</nut-button>
        </div>
      </div>
      <ExamResult
        :show="showRank"
        :rank="rank"
        @close="closeResult"
        :result="result"></ExamResult>
    </div>
  </div>
</template>

<script>
import wechatUtils from "@/api/wechat"
import examApi from "@/api/exam"
import userApi from "@/api/user"
import Subject from './components/subject.vue'
import ExamResult from '@/components/ExamResult.vue'
import { convertAddressToChinese } from '@/utils/address'

export default {
  name: 'Exam',
  components: {
    Subject,
    ExamResult,
  },
  data() {
    return {
      showShareDialog: false,
      examProgress: 1,
      examTotal: 5,
      examTime: '00:00',
      startTime: null,
      timer: null,
      data: [],
      showNext: false,
      showRank: false,
      rank: null,
      result: {},
      loading: null,
      score: 0,
    }
  },
  mounted() {
    wechatUtils.config()
    this.getList()
  },
  computed: {
    currentPercent() {
      console.log(this.examProgress / this.examTotal)
      return this.examProgress / this.examTotal * 100
    }
  },
  methods: {
    getList() {
      this.loading = this.$toast.loading('加载中...',{
        coverColor: "rgba(0,0,0,0.5)",
      })
      examApi
        .getList({})
        .then((res) => {
          this.loading.hide();
          this.data = res.questions
          this.startTiming()
        })
        .catch((e) => {
          console.log(e);
          this.$toast.text(e);
          this.loading.hide();
        });
    },
    /** 开始计时 */
    startTiming() {
      this.startTime = Date.now()
      // 定时计算开始时间与当前时间的差值
      this.timer = setInterval(() => {
        const time = Math.floor((Date.now() - this.startTime) / 1000)
        this.examTime = this.formatTime(time)
      }, 1000)
    },
    /** 把秒转换为天时分秒 */
    formatTime(time) {
      const day = Math.floor(time / 86400)
      const hour = Math.floor((time - day * 86400) / 3600)
      const minute = Math.floor((time - day * 86400 - hour * 3600) / 60)
      const second = time % 60
      if (day !== 0) {
        return `${day}天${hour}时${minute}分${second}秒`
      } else if (hour !== 0) {
        return `${`${hour}`.padStart(2, '0')}:${`${minute}`.padStart(2, '0')}:${`${second}`.padStart(2, '0')}`
      }
      return `${`${minute}`.padStart(2, '0')}:${`${second}`.padStart(2, '0')}`
    },
    /** 下一题 */
    next() {
      // 最后一题提交
      if (this.examProgress >= this.examTotal) {
        // 清除计时
        clearInterval(this.timer)
        // 隐藏下一步
        this.showNext = false
        userApi
        .exam({
          score: this.score,
        })
        .then(async (res) => {
          this.rank = ''
          const address = await convertAddressToChinese(res.province, res.city, res.county, res.town)
          this.result = {
            id: res.rank,
            address: address,
            time: this.examTime,
            fraction: this.score,
            right: this.score / 100 * this.examTotal,
            total: this.examTotal,
          }
          this.$toast.text('提交成功');
          this.loading.hide();
          this.showRank = true
        })
        .catch((e) => {
          console.log(e);
          this.$toast.text(e.response.data.detail);
          this.loading.hide();
        });
      } else {
        this.examProgress++
        this.showNext = false
      }
    },
    /** 答题回调 */
    change(e) {
      console.log(e)
      // 回答正确加分
      if (e) {
        this.score += (1 / this.examTotal) * 100
        setTimeout(() => {
          if (this.examProgress >= this.examTotal) {
            this.showNext = true
          } else {
            this.examProgress++
          }
        }, 300)
      } else {
        this.showNext = true
      }
      // 回调后设置下一题
      // this.examProgress += 1
    },
    /** 关闭答题结果 */
    closeResult() {
      this.showRank = false
      history.back()
    },
  }
}
</script>
<style lang="scss" scoped>
#app {
  background-image: none;
}
.container {
  width: 100%;
  height: 100%;
  flex: 1;
  background-color: #F29532;
}

.exam {
  width: 100%;

  &-head {
    padding: 16px 20px 0 20px;
  }

  &-head-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    color: #fff;
    line-height: 30px;
    letter-spacing: 1px;
    // font-family: 'Courier New', Courier, monospace, arial;

    .exam-progress,
    .exam-time {
      font-size: 18px;
      vertical-align: middle;
    }

  }

  &-body {
    padding-bottom: 70px;
  }

  &-foot {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #fff;
    padding: 12px 55px;
    box-sizing: border-box;
  }
}
</style>